import React from "react";

function WatchesJewelryDetails({ product }) {
    if (!product) return <p>Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    return (
        <div className="product-details">
            <h3 className="product-details-title">Saat və Zərgərlik Məhsul Məlumatları</h3>
            <div className="product-details-grid">
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Ad:</strong> {product.name || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Kategoriya:</strong> {product.category || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Brend:</strong> {product.brand || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Material:</strong> {product.material || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Cins:</strong> {product.gender || "Bilinmir"}</div>
                </div>
                <div className="product-details-column">
                    <div className="product-details-item"><strong>Əl işi?</strong> {getStatus(product.handmade)}</div>
                    <div className="product-details-item"><strong>Vəziyyət:</strong> {product.condition || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Rəng:</strong> {product.color || "Bilinmir"}</div>
                    <div className="product-details-item"><strong>Şəhər:</strong> {product.city || "Bilinmir"}</div>
                </div>
            </div>

            {product.description && (
                <div className="product-description">
                    <strong>Əlavə təsvir:</strong>
                    <p>{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default WatchesJewelryDetails;
